export const LOCAL_STORAGE_CLIENT_ID = `${window.config.bblCode}-current-client-id`
export const LOCAL_STORAGE_PRIVACY_STATEMENT = `${window.config.bblCode}-psms-portal`

export const LOCALSTORAGE_IDENTITY_PREFIX = `${window.config.bblCode}-ngtportal.`
export const LOCALSTORAGE_IDENTITY_PREFIX_LANDING = 'ngtlanding.'
export const LOCALSTORAGE_IDENTITY_PREFIX_MS = 'ngtms.'
export const LOCALSTORAGE_IDENTITY_PREFIX_PREEMPTION = 'ngtpreemption.'

export const LOCAL_STORAGE_REDIRECT_URL = 'ngtportal-redirect'

export const LOCAL_STORAGE_REDIRECT_URL_LOGOUT = 'ngtportal-redirect-logout'

export const LOCAL_STORAGE_UNSUPPORTED_BROWSER_CONTINUE =
  'ngtms-unsupb-portal-ignore'

export const LOCAL_STORAGE_REFERRER_SITE = `${window.config.bblCode}-ngtms-referrer-site`
